import { render, staticRenderFns } from "./productLimit.vue?vue&type=template&id=04a2b3d0&scoped=true"
import script from "./productLimit.vue?vue&type=script&lang=js"
export * from "./productLimit.vue?vue&type=script&lang=js"
import style0 from "./productLimit.vue?vue&type=style&index=0&id=04a2b3d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a2b3d0",
  null
  
)

export default component.exports